<div class="container-fluid section pt-3">
    <span class="header px-3">Chats</span>
    <div class="chat-list mt-3" *ngIf="chatList.length">
        <div *ngFor="let person of chatList; let i = index">
            <div class="d-flex flex-row px-3 py-2 list-item" (click)="selectChat(i)" *ngIf="person.mum"
                [ngClass]="{active: selected == i}">
                <div class="img-section">
                    <img class="profile-img" *ngIf="person.mum?.profileImage" [src]="person.mum?.profileImage">
                    <img class="profile-img" *ngIf="!person.mum?.profileImage"
                        src="../../../../../../assets/Images/pro-pic.png">
                </div>
                <div class="d-flex flex-column ml-3 excess-content w-100">
                    <div class="d-flex flex-row justify-content-between">
                        <span class="title flex-grow">{{person.mum?.name}}</span>
                        <span class="notify-time ml-2" *ngIf="person.timestamp">{{person.timestamp | timeago}}</span>
                    </div>
                    <span class="sub-title pr-2">{{person.lastMessage}}</span>
                </div>
            </div>
            <div class="d-flex flex-row px-3 py-2 list-item" (click)="selectChat(i)" *ngIf="person.midwife"
                [ngClass]="{active: selected == i}">
                <div class="img-section">
                    <img class="profile-img" *ngIf="person.midwife?.profileImage" [src]="person.midwife?.profileImage">
                    <img class="profile-img" *ngIf="!person.midwife?.profileImage"
                        src="../../../../../../assets/Images/pro-pic.png">
                </div>
                <div class="d-flex flex-column ml-3 excess-content w-100">
                    <div class="d-flex flex-row justify-content-between">
                        <span class="title flex-grow">{{person.midwife?.name}}</span>
                        <span class="notify-time ml-2" *ngIf="person.timestamp">{{person.timestamp |
                            timeago}}</span>
                    </div>
                    <span class="sub-title pr-2">{{person.lastMessage}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="no-data" *ngIf="!chatList.length && !loading">
        <img class="align-self-center" src="../../../../../../assets/Images/NoDocuments.png" height="50" width="80"
            alt="No Chats">
        <span>No chats</span>
    </div>
</div>